module.exports = __webpack_public_path__ + "manageStatic/img/logo_android.0f32e59b.png";